import { observer } from 'mobx-react';
import { PAYMENT_TYPES } from '@nandosaus/constants';
import { useRootStore } from '@nandosaus/state-management';
import React from 'react';

import { Alert } from '../../../alert';
import { Box, Flex } from '../../../grid';
import { P } from '../../../typography';
import { RemoveButton } from '../../../remove-button';

const SelectedGiftCard = observer(() => {
  const { OrderStore, CartStore, MemberStore } = useRootStore();
  const { giftCard, removeGiftCard } = OrderStore.payment;

  const { splitAmountGiftCardFormatted, removeSplitPaymentType } = CartStore;
  let alertMessage;
  if (giftCard.hasExpired) {
    alertMessage = `This gift card expired on ${giftCard.formattedExpiryDate}. Please choose a different payment method.`;
  }
  if (giftCard.balance === 0) {
    alertMessage = `This gift card has no funds left. Please choose a different payment method.`;
  }

  return (
    <>
      {alertMessage && (
        <Box mb={1}>
          <Alert type="error">{alertMessage}</Alert>
        </Box>
      )}

      <Flex flexDirection="column" px={2} py={3} mb={1} borderWidth="1px" borderStyle="solid" borderColor="grey100">
        <Flex justifyContent="space-between" alignItems="center">
          <Box width={{ _: '70%', sm: '50%' }}>
            <Flex mb="0.5rem" width="100%" justifyContent="space-between">
              <P fontWeight="bold" mr={1}>
                Gift Card Balance
              </P>
              <P>{giftCard.formattedBalance}</P>
            </Flex>
            <Flex justifyContent="space-between">
              <P fontWeight="bold" mr={1}>
                Redeeming
              </P>
              <P>{splitAmountGiftCardFormatted}</P>
            </Flex>
          </Box>
          <Box ml={1}>
            <RemoveButton
              onConfirm={() => {
                removeGiftCard();
                if (!MemberStore.isSignedIn) {
                  // else there's no way to un-set gift card as a payment type, since we don't show the button on guest
                  removeSplitPaymentType(PAYMENT_TYPES.GIFT_CARD);
                }
              }}
            >
              Remove
            </RemoveButton>
          </Box>
        </Flex>
      </Flex>
    </>
  );
});

export { SelectedGiftCard };
